// Safari restores a bfcache page with whatever element was focused right before
// navigating away still focused. Card links (.product-card__link, .collection-card__link,
// .card__link, .featured-blog-posts-card__link in assets/base.css) cover the entire card
// via position:absolute; inset:0, so the global *:focus-visible outline (assets/base.css)
// then draws a solid box around the whole card — visible after tapping a card and hitting
// back. Blurring the stale focus on restore clears it without touching real keyboard
// focus-visible behaviour during a live page session.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  const active = document.activeElement;
  if (active instanceof HTMLElement && active !== document.body) {
    active.blur();
  }
});
